import { Injectable } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';
import { assign } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private toastController: ToastController,
    private translate: TranslateService
  ) { }

  async show(message = 'SHARED.Update_Success', prefix?: string, params?: Object) {
    return this.present(message, { duration: 3000 }, prefix, params);
  }

  /**
   * Show an error toast that does NOT auto-dismiss (duration 0): it stays until
   * the user clicks the × button. Use for failures the user must not miss if
   * they have looked away (e.g. copy/move failures).
   */
  async showError(message = 'SHARED.Update_Failed', prefix?: string, params?: Object) {
    return this.present(message, { duration: 0, cssClass: 'custom-toast custom-toast-error' }, prefix, params);
  }

  private async present(message: string, defaults: Partial<ToastOptions>, prefix?: string, params?: Object) {
    let msg = this.translate.instant(message);
    if (prefix) {
      msg = `${this.translate.instant(prefix)}: ${msg}`
    }

    const toast = await this.toastController.create(assign({
      message: msg,
      cssClass: 'custom-toast',
      position: 'middle',
      buttons: [{
        text: '×',
        role: 'cancel'
      }]
    } as ToastOptions, defaults, params));
    await toast.present();
  }

  async showUpdatedSuccess(prefix?: string, params?: Object) {
    this.show('SHARED.Update_Success', prefix, params);
  }

  async showAddedSuccess(prefix?: string, params?: Object) {
    this.show('SHARED.Added_success', prefix, params);
  }

  async showDeletedSuccess(prefix?: string, params?: Object) {
    this.show('SHARED.Deleted_success', prefix, params);
  }
}
